export default "__VITE_ASSET__D6iUBL24__"